
/**
 * @description
 * 랭킹 큐레이션용 스켈레톤
 */
export default {
  name: 'RankingCurationSkeleton',
};
